export default {
    computed: {
        custom() {
            return !this.plain;
        }
    },
    props: {
        plain: {
            type: Boolean,
            default: false
        }
    }
};



//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/lib/mixins/form-custom.js
// module id = 107
// module chunks = 2